import React from 'react'
import UserLogin from '../../components/UserLogin/UserLogin'

function LoginPage() {
  return (
        <UserLogin/>
  )
}

export default LoginPage